import React from 'react'
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core/styles'
import desertFloraTheme from '../../styles/desertFloraTheme'
import '../../styles/desertFlora.css'
import '../../styles/hmiReskin.css'
import BidEstimationProjectsDashboard from './BidEstimationProjectsDashboard'
import RateTablesView from './RateTables/RateTablesView'
import LineItemsView from './LineItems/LineItemsView'
import ProjectDashboard from './ProjectDashboard/ProjectDashboard'
import BidOutputView from './Output/BidOutputView'
import VendorQuotesTab from './VendorQuotes/VendorQuotesTab'
import BidResponseWorkspace from './BidResponse/BidResponseWorkspace'
import ModuleWorkspace from './ModuleWorkspace/ModuleWorkspace'
import EstimateReviewView from './EstimateReview/EstimateReviewView'
import PostCloseView from './PostClose/PostCloseView'
import MaterialsRollupView from './Materials/MaterialsRollupView'
import ServiceBuilderView from './ServiceBuilder/ServiceBuilderView'
import InBidRatesView from './Rates/InBidRatesView'
import EstimatingCockpit from './Estimating/EstimatingCockpit'
import ScopeReconciler from './Scope/ScopeReconciler'
import PlanTakeoffWorkspace from './PlanTakeoff/PlanTakeoffWorkspace'
import BidAssemblyPipeline from './Assembly/BidAssemblyPipeline'
import RecipeBuilderV2 from './ServiceRecipes/v2/RecipeBuilderV2'
import SubmittalEditor from '../Submittals/SubmittalEditor'

const BidEstimation = (props) => {
  const { path } = useRouteMatch()

  return (
    <ThemeProvider theme={desertFloraTheme}>
    <Switch>
      <Route exact path={path} render={() => <BidEstimationProjectsDashboard {...props} />} />
      <Route path={`${path}/rates`} render={() => <RateTablesView {...props} />} />
      <Route path={`${path}/:projectId/items`} render={() => <LineItemsView {...props} />} />
      <Route path={`${path}/:projectId/output`} render={() => <BidOutputView {...props} />} />
      <Route path={`${path}/:projectId/vendor-quotes`} render={(routeProps) => <VendorQuotesTab projectId={routeProps.match.params.projectId} {...props} />} />
      <Route path={`${path}/:projectId/bid-response/:packageId`} render={(routeProps) =>
        <BidResponseWorkspace
          projectId={routeProps.match.params.projectId}
          packageId={routeProps.match.params.packageId}
          {...props}
        />
      } />
      <Route path={`${path}/:projectId/estimate-review`} render={() => <EstimateReviewView {...props} />} />
      <Route path={`${path}/:projectId/post-close`} render={() => <PostCloseView {...props} />} />
      <Route path={`${path}/:projectId/materials`} render={() => <MaterialsRollupView {...props} />} />
      <Route path={`${path}/:projectId/submittals/:submittalId`} render={(routeProps) => (
        <SubmittalEditor
          submittalId={routeProps.match.params.submittalId}
          {...props}
        />
      )} />
      <Route path={`${path}/:projectId/modules/:moduleId`} render={(routeProps) => <ModuleWorkspace {...routeProps} {...props} />} />
      <Route path={`${path}/:projectId/recipe-builder`} render={() => <RecipeBuilderV2 />} />
      <Route path={`${path}/:projectId/service-builder`} render={() => <ServiceBuilderView {...props} />} />
      <Route path={`${path}/:projectId/rates`} render={() => <InBidRatesView {...props} />} />
      <Route path={`${path}/:projectId/estimating`} render={() => <EstimatingCockpit />} />
      <Route path={`${path}/:projectId/scope`} render={() => <ScopeReconciler />} />
      <Route path={`${path}/:projectId/plan-takeoff/:docId`} render={() => <PlanTakeoffWorkspace {...props} />} />
      <Route path={`${path}/:projectId/legacy-assembly`} render={() => <BidAssemblyPipeline />} />
      <Route path={`${path}/:projectId/assembly`} render={(routeProps) => (
        <Redirect to={`${path}/${routeProps.match.params.projectId}/scope`} />
      )} />
      <Route path={`${path}/:projectId`} render={() => <ProjectDashboard {...props} />} />
    </Switch>
    </ThemeProvider>
  )
}

export default BidEstimation
